export function HomeHeader() {
  return (
    <header className="sticky top-0 z-50 bg-background/95 backdrop-blur shadow-sm">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-3 md:py-0">
        {/* Top row: Logo and Contact (+ desktop nav) */}
        <div className="flex items-center justify-between md:h-16">
          <a href="/" className="flex-shrink-0">
            <img
              src="/assets/logos/recovery-jobs.png"
              alt="Recovery Jobs"
              className="h-8"
            />
          </a>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-8">
            <a
              href="/clients"
              className="text-sm font-medium text-foreground hover:text-accent transition-colors duration-200"
            >
              Individual
            </a>
            <a
              href="/centers"
              className="text-sm font-medium text-foreground hover:text-accent transition-colors duration-200"
            >
              Treatment Center
            </a>
          </nav>

          <a
            href="mailto:program@recovery-jobs.com"
            className="rounded-md bg-accent px-4 py-2 md:px-5 md:py-2.5 text-sm font-semibold text-accent-foreground hover:bg-accent/90 transition-colors"
          >
            Contact Us
          </a>
        </div>

        {/* Mobile nav - centered second row */}
        <nav className="flex md:hidden items-center justify-center gap-8 pt-3 mt-3 border-t border-border/30">
          <a
            href="/clients"
            className="text-sm font-medium text-foreground hover:text-accent transition-colors duration-200"
          >
            Individual
          </a>
          <a
            href="/centers"
            className="text-sm font-medium text-foreground hover:text-accent transition-colors duration-200"
          >
            Treatment Center
          </a>
        </nav>
      </div>
    </header>
  );
}
